module.exports = function() {
  return new Worker(__webpack_public_path__ + "11cc4958207b73c95e33.worker.js");
};